import React from "react";
import useNumberFormatter from "../../../../hooks/useNumberFormatter";

const ViewPaymentsDetails = ({ data }) => {
  const numericFormatter = useNumberFormatter();
  const {
    customer_name,
    sales_code,
    sales_date,
    grand_total,
    paid_amount,
    phone,
    emp_id,
  } = data || {};
  const totalDue = (grand_total || 0) - (paid_amount || 0);
  const changeReturn = (paid_amount || 0) - (grand_total || 0);
  return (
    <section className="d-flex justify-content-between align-items-start mb-4">
      <div>
        <h6 className="mb-0 text-black fs-6 fw-800">Customer Details</h6>
        <p className="m-0 text-dark fw-bold">{customer_name || "-"}</p>
        {emp_id && (
          <p className="m-0 text-dark fw-bold">Customer Id: {emp_id || "-"}</p>
        )}
        {phone && (
          <p className="m-0 text-dark fw-bold">Phone: {phone || "-"}</p>
        )}
      </div>
      <div>
        <h6 className="mb-0 text-black fs-6 fw-800">Payment Details</h6>
        <p className="m-0 text-dark fw-bold">
          Grand total: {numericFormatter(grand_total) || "-"}
        </p>
        <p className="m-0 text-dark fw-bold">
          Paid Amount: {numericFormatter(paid_amount) || "-"}
        </p>
        {grand_total >= paid_amount && (
          <p className="m-0 text-dark fw-bold">
            Due: {numericFormatter(totalDue) || "-"}
          </p>
        )}
        {paid_amount > grand_total && (
          <p className="m-0 text-dark fw-bold">
            Change Return: {numericFormatter(changeReturn) || "-"}
          </p>
        )}
      </div>
      <div>
        <h6 className="mb-0 text-black fs-6 fw-800">Sales Details</h6>
        <p className="m-0 text-dark fw-bold">Invoice:#{sales_code || "-"}</p>
        <p className="m-0 text-dark fw-bold">
          Date:{sales_date?.slice(0, 10) || "-"}
        </p>
      </div>
    </section>
  );
};

export default ViewPaymentsDetails;
